import { Autocomplete, Box, Card, Modal, TextField } from '@mui/material';
import { useRef } from 'react';

import { client } from '@frontend/features/common/services';
import { useSnackBar } from '@frontend/features/common/components/SnackBarContext';
import { useTranslation } from 'react-i18next';
import { useGetClientsByAgency } from '@frontend/features/clients/queries';
import { useDebouncedState } from '@frontend/features/common/hooks/useDebouncedState';
import { OptionType } from '@frontend/features/common/types';
import { useQueryClient } from 'react-query';

interface Props {
  isOpen: boolean;
  organizationId: number;
  agencyId: number;
  onClose: () => void;
  queryKey?: unknown;
}

export const LinkClientToOrganization = ({ isOpen, onClose, organizationId, queryKey, agencyId }: Props) => {
  const { addToast } = useSnackBar();
  const queryClient = useQueryClient();
  const [autocompleteValue, setAutocompleteValue] = useDebouncedState<string>('', 500);
  const { t } = useTranslation();
  const formRef = useRef<HTMLFormElement>(null);
;
  const { data: clientList } = useGetClientsByAgency({
    agencyId,
    pageSize: 10,
    currentPage: 1,
    search: autocompleteValue,
  });

  const listOptionscaseAgentListOption =
  clientList?.items?.map((client) => ({
      value: client.id,
      label: `${client.firstName} ${client.lastName} - ${client.email}`,
    })) ?? [];

  const handleChange = async (userItem: OptionType | null) => {
    try {
      await client.post(`/organizations/${organizationId}/client/${userItem?.value}`);

      addToast({
        message: t('organizations.linkUserToOrganization.success'),
        color: 'success',
      });

      queryKey && queryClient.invalidateQueries(queryKey);
      onClose();
    } catch (_e) {
      addToast({
        message: t('teams.linkUserToOrganization.error'),
        color: 'error',
      });
    }
  };

  const handleCancel = () => {
    setAutocompleteValue('');
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: 800,
          p: 2,
        }}
        elevation={4}
      >
        <Box ref={formRef} component="form" display="flex" gap={2}>
          <Autocomplete
            fullWidth
            options={listOptionscaseAgentListOption}
            getOptionLabel={(option) => option.label}
            onChange={(_event: React.SyntheticEvent, newValue: OptionType | null) => {
              handleChange(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                autoFocus
                onChange={(e) => {
                  setAutocompleteValue(e.target.value);
                }}
                onKeyDown={(e) => {
                  e.nativeEvent.key === 'Escape' && handleCancel();
                }}
                variant="outlined"
              />
            )}
          />
        </Box>
      </Card>
    </Modal>
  );
};
